/* global WalkMeAPI */
angular.module('kareo.ui.shared.modules.walkme', ['kareo.ui.shared.modules.data']).provider('KareoWalkme', [
  function () {
    /*
     Walkme Notes:
     1. The Walkme script snippet makes several thing available on the window when its ready
     * The 'WalkMeAPI' object - this is their api we interact with.
     * 'walkme_ready' method - this method is called when Walkme is ready and loaded.  We implement as necessary.
     * 'walkme_event(eventData)' method - this method is called after Walkme events, with eventData object.  We implement as necessary.

     */
    function getSrc() {
      // hacking it for now
      var envStr = '';
      if (window.location.hostname.indexOf('app.kareo.com') < 0) {
        envStr = '/test';
      }
      return 'https://cdn.walkme.com/users/c34d6f0df16348dd8edb8ca5ccf9fb31' + envStr + '/walkme_c34d6f0df16348dd8edb8ca5ccf9fb31_https.js';
    }

    this.initialize = function () {
      if (!window.WalkMeAPI) {
        var walkme = document.createElement('script');
        walkme.type = 'text/javascript';
        walkme.async = true;
        walkme.src = getSrc();
        var s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(walkme, s);
        window._walkmeConfig = { smartLoad: true };
      }
    };
    // need to just code this in here for now, until we make a decision on which tours are walkme
    this.tours = [
      {
        id: 0, name: 'NOTES_TOUR', walkthruId: 0
      }, {
        id: 1, name: 'CALENDAR_TOUR', walkthruId: 0
      }, {
        id: 7, name: 'PSYCH_PROGRESS_NOTE_TOUR', walkthruId: 0
      }, {
        id: 8, name: 'GROUP_APPOINTMENT_TOUR', walkthruId: 0
      }];
    this.$get = [
      'authenticatedUser', '$filter', '$window', function (authenticatedUser, $filter, $window) {
        var initialize = this.initialize;
        var tours = this.tours;
        var walkthruCompletedHandler;
        var WALK_THRU_COMPLETED = 'WalkthruCompleted';
        var TOUR_COMPLETED_STATUS = 2;

        function getWalkthrus() {
          if ($window.WalkMeAPI && !this.walkthrus) {
            this.walkthrus = $window.WalkMeAPI.getWalkthrus();
          }
          return this.walkthrus;
        }

        function setTourIds() {
          var walkthru = null;
          angular.forEach(tours, function (value, key, obj) {
            walkthru = $filter('filter')(this.walkthrus, { CustomField1: value.name })[0];
            if (walkthru) {
              value.walkthruId = walkthru.Id;
            }
          });
        }

        function getWalkthruId(tourId) {
          var tour = $filter('filter')(tours, { id: tourId })[0];
          return tour ? tour.walkthruId : -1;
        }

        // WalkmeAPI will call walkme_ready method on window when WalkMeAPI object is ready
        $window.walkme_ready = function () {
          getWalkthrus();
          setTourIds();
        };
        // WalkmeAPI will call walkme_event method on window on WalkMe events
        $window.walkme_event = function (eventData) {
          if (eventData.Type === WALK_THRU_COMPLETED) {
            var tourId = $filter('filter')(tours, { walkthruId: eventData.WalkthruId })[0].id;
            authenticatedUser.updateTourStatuses([
              {
                'tour': tourId, 'tourStatus': TOUR_COMPLETED_STATUS
              }]).then((response) => {
                if (walkthruCompletedHandler instanceof Function) {
                  walkthruCompletedHandler();
                }
              });
          }
        };
        var service = {
          initialize() {
            initialize();
          }, getWalkthrus() {
            return WalkMeAPI.getWalkthrus();
          }, startWalkthruById(walkThruId) {
            return WalkMeAPI.startWalkthruById(walkThruId);
          }, startWalkthruByTourId(tourId) {
            return WalkMeAPI.startWalkthruById(getWalkthruId(tourId));
          }, setWalkthruCompletedHandler(callback) {
            walkthruCompletedHandler = callback;
          }
        };
        return service;
      }];
  }]);
